import useReactions from '../../hooks/chat/useReactions'
import { useUser } from '../../hooks/user/useUser'
import Activity from '../../model/Activity'
import ActivityLog from '../../model/ActivityLog'
import Message from '../../model/Message'
import ChatMessageBubble from '../../ui/chat/ChatMessageBubble'

export interface ChatMessageBubbleContainerProps {
  message: Message
  messages: Message[]
  isOwnMessage: boolean
  isFirstInChain: boolean
  isLastInChain: boolean
  onReply?: (message: Message) => void
  onScrollToMessage?: (messageId: string) => void
  activityLogsMap: Map<string, ActivityLog>
  activitiesMap: Map<string, Activity>
}

export default function ChatMessageBubbleContainer(props: ChatMessageBubbleContainerProps) {
  const { data: user } = useUser()
  const { reactions, addOrUpdateReaction, removeReaction } = useReactions(props.message.id)

  async function onToggleReaction(emoji: string, existingReactionId?: number) {
    if (!user) return
    if (existingReactionId) {
      await removeReaction(existingReactionId)
    } else {
      await addOrUpdateReaction(emoji)
    }
  }

  async function onEmojiReaction(emoji: string) {
    await addOrUpdateReaction(emoji)
  }

  return (
    <ChatMessageBubble
      {...props}
      currentUserId={user?.id}
      reactions={reactions}
      onEmojiReaction={onEmojiReaction}
      onToggleReaction={onToggleReaction}
    />
  )
}
